import React, { useState } from 'react';
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Collapse,
    TextField,
    Menu,
    MenuItem,
    Stack,
    IconButton,
} from "@mui/material";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const PinInput = ({ name, onSubmit, updatePin }) => {
    const [pin, setPin] = useState("");
    const [pin1, setPin1] = useState("");
    const [pin2, setPin2] = useState("");
    const [validationError, setValidationError] = useState(false);

    const [updatePinMode, setUpdatePinMode] = useState(false);

    const loginHandler = (e) => {

        if ((e?.key === 'Enter' && pin.trim() !== '') || !e) {

            if (pin === "0000") {
                setUpdatePinMode(true);
                return;
            } else {
                onSubmit({ pin })
            }
        }
    };

    const updatePinHandler = () => {

        if(pin1 === "0000"){}{
            setValidationError("Password darf nicht 0000 sein")
        }

        if (pin1 !== pin2) {
            setValidationError("Password Wiederholung stimmt nicht überein")
            return;
        }

        if (pin1.length < 4) {
            setValidationError("Password zu kurz")
            return;
        }

        updatePin({ pin, newPin: pin1 })
    };


    return (
        <Box>
            <Box sx={{ display: 'flex', gap:2 }}>

                <TextField
                    size='large'
                    type="password"
                    value={pin}
                    onChange={(evt) => setPin(evt.target.value)}
                    label={`Password von ${name}`}
                    onKeyDown={loginHandler}
                    autoFocus
                />
                <PrimaryButtonWithActions
                    mainLabel="Login"
                    onMainClick={() => loginHandler()}
                    secondaryActions={[
                        { label: 'Password ändern', onClick: () => setUpdatePinMode(true) },
                    ]}
                />
            </Box>
            <Collapse in={updatePinMode}>
                <Box sx={{ my: 2 }}>
                    <Alert severity="info">
                        <AlertTitle>Neues Password vergeben</AlertTitle>
                        Ein Password nutzen, die ausschließlich für die Kasse verwendet wird.
                        Altes Passwort ^ oben eingeben.
                        Unten zweimal das neue eingeben.
                    </Alert>
                </Box>
                {validationError &&
                    <Box sx={{ my: 2 }}>

                        <Alert severity='error'>{validationError}</Alert>
                    </Box>
                }
                <Box sx={{ my: 2 }}>
                    <TextField
                        size='small'
                        type="password"
                        value={pin1}
                        onChange={(evt) => setPin1(evt.target.value)}
                        label="Neues Password"
                        onKeyDown={loginHandler}
                    />
                </Box>
                <Box sx={{ my: 2 }}>
                    <TextField
                        size='small'
                        type="password"
                        value={pin2}
                        onChange={(evt) => setPin2(evt.target.value)}
                        label="Neues Password wiederholen"
                        onKeyDown={loginHandler}
                    />
                </Box>
                <Button variant="outlined" onClick={updatePinHandler}>Speichern</Button>

            </Collapse>
        </Box>
    );
};

export default PinInput;





const PrimaryButtonWithActions = ({ mainLabel, onMainClick, secondaryActions }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <Stack direction="row" spacing={0}>
            <Button variant="contained" onClick={onMainClick}>
                {mainLabel}
            </Button>
            <IconButton
                color="primary"
                size="large"
                onClick={handleMenuOpen}

                sx={{ border: '1px solid rgba(0, 0, 0, 0.23)', borderLeft: 0, borderRadius: 0 }}
            >
                <ArrowDropDownIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                {secondaryActions.map((action, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            action.onClick();
                            handleMenuClose();
                        }}
                    >
                        {action.label}
                    </MenuItem>
                ))}
            </Menu>
        </Stack>
    );
};

